import { Snackbar, Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useNotificationStore, Notification } from '@/store/notificationStore';

function NotificationItem({ notification }: { notification: Notification }) {
  const navigate = useNavigate();
  const removeNotification = useNotificationStore((state) => state.removeNotification);

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    removeNotification(notification.id);
  };

  const handleActionClick = () => {
    if (notification.action?.href) {
      navigate(notification.action.href);
    }
    if (notification.action?.onClick) {
      notification.action.onClick();
    }
    removeNotification(notification.id);
  };

  return (
    <Snackbar
      open={true}
      autoHideDuration={notification.autoHide ? notification.autoHideDuration : null}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 2 }}
    >
      <Alert
        onClose={handleClose}
        severity={notification.severity}
        variant="filled"
        sx={{ minWidth: 300, maxWidth: 500, alignItems: 'center' }}
        action={
          notification.action ? (
            <Button
              color="inherit"
              size="small"
              onClick={handleActionClick}
              sx={{ fontWeight: 600 }}
            >
              {notification.action.label}
            </Button>
          ) : undefined
        }
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}

export function NotificationProvider() {
  const notifications = useNotificationStore((state) => state.notifications);

  // Only show the most recent notification
  const currentNotification = notifications[notifications.length - 1];

  if (!currentNotification) {
    return null;
  }

  return <NotificationItem key={currentNotification.id} notification={currentNotification} />;
}
